import React from 'react'
import PropTypes from 'prop-types'
import { useAiMessage } from '../../../../api/denaliAssistant'
import Loading from '../../../../components/molecules/Loading'
import Message from '../Chat/Message'
import { AttachmentProvider } from '../contexts/AttachmentContext'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import Background from '../../../../providers/BackgroundProvider/Background'

function MessageById ({ parentInfo, messageId, preContent, postContent, showMood, hideMessageHeader }) {
  const { data, isLoading } = useAiMessage(parentInfo, messageId)

  if (isLoading) {
    return (
      <Loading />
    )
  }

  if (!data?.message) return null

  return (
    <Background
      light={showMood ? 'center / cover no-repeat url(https://resources.swsapp.com/100/images/purpleMountains.webp)' : undefined}
    >
      <AttachmentProvider>
        {preContent ? (
          <FadeIn>{preContent}</FadeIn>
        ) : null}
        <Message message={data.message} hideMessageHeader={hideMessageHeader} />
        {postContent ? (
          <FadeIn>{postContent}</FadeIn>
        ) : null}
      </AttachmentProvider>
    </Background>
  )
}

MessageById.propTypes = {
  parentInfo: PropTypes.object,
  messageId: PropTypes.string,
  preContent: PropTypes.node,
  postContent: PropTypes.node,
  showMood: PropTypes.bool,
  hideMessageHeader: PropTypes.bool
}

export default MessageById
